import { ICONS } from "../../../../../../components/icons/GenericIconPicker"
import { ToggleWF } from "../Workflows/FacilityBreakdownWorkFlowComponent"

export const FacilityBreakdownCalendarComponent = ({ calendar }) => {
    const findProp = (prop, parse) => {
        const res = calendar.properties.find(p => p.name === prop)
        // console.log('FacilityBreakdownCalendarComponent a', res, calendar.properties)
        return res ? parse ? JSON.parse(res.value) : res.value : undefined
    }
    return (
        <div className="bg-light text-dark rounded p-2 m-2" style={{ fontSize: '1rem' }}>
            <ToggleWF title={calendar.eventName}>
                <div style={{ background: findProp('BACKGROUND_COLOUR', true) }}>
                    <div>{findProp('ICONS', true) && findProp('ICONS', true).map(icon => <div>{ICONS.find(f => f.name && f.name === icon).icon}</div>)}</div>
                    <div>When triggered will {calendar.whenTriggered.description.toLowerCase()}</div>
                    <div>{calendar.availableCalendars ? `Available on` : `Unavailable`}
                        <ul>
                            {calendar.availableCalendars &&
                                <ul>
                                    {calendar.availableCalendars.map(a => <li>{a.calendarType.description}</li>)}
                                </ul>
                            }
                        </ul>
                    </div>
                </div>
            </ToggleWF>
        </div>)
}
